const roles = ['Student', 'Responsible', 'Team', 'Staff']

export default roles
